(function () {
  if (window.__lgIosFormsPopupFix) return;
  window.__lgIosFormsPopupFix = true;

  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  if (!isIOS()) return;

  var POPUP_SELECTOR = [
    '[data-testid="modal-container"]',
    '[class*="ecomsend"]',
    '[class*="react-responsive-modal"]',
    '[class*="shopify-forms"]',
    '[id*="shopify-forms"]',
    '[id*="forms"]',
    '[class*="forms"]'
  ].join(',');

  var CLICKABLE_SELECTOR = [
    'button',
    'a',
    'label',
    'input[type="checkbox"]',
    'input[type="radio"]',
    '[role="button"]',
    '[role="checkbox"]',
    '[role="radio"]',
    '[tabindex]',
    '[data-testid*="option"]',
    '[data-testid*="choice"]',
    '[data-testid*="close"]',
    '[class*="option"]',
    '[class*="choice"]',
    '[class*="close"]',
    '[class*="answer"]'
  ].join(',');

  var style = document.createElement('style');
  style.id = 'lg-ios-forms-popup-fix-style';
  style.textContent = [
    POPUP_SELECTOR + '{pointer-events:auto!important;-webkit-transform:translateZ(0)!important;transform:translateZ(0)!important}',
    POPUP_SELECTOR + ' *{touch-action:manipulation!important;-webkit-tap-highlight-color:transparent!important}',
    POPUP_SELECTOR + ' button,' + POPUP_SELECTOR + ' a,' + POPUP_SELECTOR + ' label,' + POPUP_SELECTOR + ' input,' + POPUP_SELECTOR + ' [role="button"],' + POPUP_SELECTOR + ' [role="checkbox"],' + POPUP_SELECTOR + ' [role="radio"],' + POPUP_SELECTOR + ' [tabindex],' + POPUP_SELECTOR + ' [class*="option"],' + POPUP_SELECTOR + ' [class*="choice"]{cursor:pointer!important;pointer-events:auto!important}'
  ].join('\n');
  document.head.appendChild(style);

  function closestPopup(target) {
    return target && target.closest && target.closest(POPUP_SELECTOR);
  }

  function closestClickable(target) {
    if (!target || !target.closest) return null;
    return target.closest(CLICKABLE_SELECTOR);
  }

  function isTextControl(el) {
    if (!el) return false;
    var tag = (el.tagName || '').toLowerCase();
    var type = (el.getAttribute('type') || '').toLowerCase();
    return tag === 'textarea' || tag === 'select' ||
      (tag === 'input' && !/^(checkbox|radio|button|submit|reset)$/i.test(type));
  }

  function getPoint(event) {
    var touch = event.changedTouches && event.changedTouches[0] || event.touches && event.touches[0];
    return touch ? { x: touch.clientX, y: touch.clientY } : { x: 0, y: 0 };
  }

  function fireMouseSequence(el, point) {
    ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (type) {
      var event;
      if (type.indexOf('pointer') === 0 && window.PointerEvent) {
        event = new PointerEvent(type, {
          bubbles: true,
          cancelable: true,
          pointerType: 'touch',
          isPrimary: true,
          clientX: point.x,
          clientY: point.y,
          view: window
        });
      } else {
        event = new MouseEvent(type, {
          bubbles: true,
          cancelable: true,
          clientX: point.x,
          clientY: point.y,
          view: window
        });
      }
      el.dispatchEvent(event);
    });
  }

  var lastHandledAt = 0;
  var lastTarget = null;

  document.addEventListener('touchend', function (event) {
    var popup = closestPopup(event.target);
    if (!popup) return;

    var clickable = closestClickable(event.target);
    if (!clickable || isTextControl(clickable)) return;

    var now = Date.now();
    if (clickable === lastTarget && now - lastHandledAt < 500) return;
    lastTarget = clickable;
    lastHandledAt = now;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var point = getPoint(event);
    setTimeout(function () {
      if (!document.documentElement.contains(clickable)) return;

      if (clickable.tagName && clickable.tagName.toLowerCase() === 'label') {
        var forId = clickable.getAttribute('for');
        var input = forId ? document.getElementById(forId) : clickable.querySelector('input[type="checkbox"], input[type="radio"]');
        if (input) {
          fireMouseSequence(input, point);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }

      fireMouseSequence(clickable, point);
    }, 0);
  }, true);
})();

(function () {
  var WHATSAPP_URL = 'https://wa.me/message/HM3QRAOOVY5AD1';
  var lastRedirectAt = 0;
  var touchStart = null;
  var moved = false;
  var MOVE_THRESHOLD = 12;

  function isProductPage() {
    return document.body && document.body.classList.contains('template-product');
  }

  function isWhatsappElement(el) {
    if (!el) return false;
    var text = (el.textContent || '').toLowerCase();
    var href = (el.getAttribute && el.getAttribute('href') || '').toLowerCase();
    var cls = (el.className || '').toString().toLowerCase();
    return cls.indexOf('luminary-whatsapp-product-btn') !== -1 ||
      text.indexOf('whatsapp') !== -1 ||
      href.indexOf('wa.me') !== -1 ||
      href.indexOf('api.whatsapp.com') !== -1 ||
      href.indexOf('whatsapp') !== -1;
  }

  function findWhatsappTrigger(target) {
    if (!target || !target.closest) return null;
    var el = target.closest('a, button, [role="button"]');
    return isWhatsappElement(el) ? el : null;
  }

  function updateWhatsappLinks(root) {
    if (!isProductPage()) return;
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a.luminary-whatsapp-product-btn, a[href*="wa.me"], a[href*="api.whatsapp.com"], a[href*="whatsapp"]').forEach(function (link) {
      if (!isWhatsappElement(link)) return;
      link.setAttribute('href', WHATSAPP_URL);
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener');
      link.style.touchAction = 'pan-y';
    });
  }

  function getTouchPoint(event) {
    var touch = event.touches && event.touches[0] || event.changedTouches && event.changedTouches[0];
    return touch ? { x: touch.clientX, y: touch.clientY } : null;
  }

  function onTouchStart(event) {
    if (!isProductPage() || !findWhatsappTrigger(event.target)) {
      touchStart = null;
      moved = false;
      return;
    }
    touchStart = getTouchPoint(event);
    moved = false;
  }

  function onTouchMove(event) {
    if (!touchStart) return;
    var point = getTouchPoint(event);
    if (!point) return;
    if (Math.abs(point.x - touchStart.x) > MOVE_THRESHOLD || Math.abs(point.y - touchStart.y) > MOVE_THRESHOLD) {
      moved = true;
    }
  }

  function onTouchEnd(event) {
    if (!touchStart) return;
    var trigger = findWhatsappTrigger(event.target);
    var shouldOpen = trigger && !moved;
    touchStart = null;
    moved = false;

    if (!shouldOpen) return;
    openWhatsapp(event);
  }

  function openWhatsapp(event) {
    if (!isProductPage()) return;
    var trigger = findWhatsappTrigger(event.target);
    if (!trigger) return;

    var now = Date.now();
    if (now - lastRedirectAt < 800) return;
    lastRedirectAt = now;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    if (trigger.tagName && trigger.tagName.toLowerCase() === 'a') {
      trigger.setAttribute('href', WHATSAPP_URL);
    }

    window.location.href = WHATSAPP_URL;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { updateWhatsappLinks(document); });
  else updateWhatsappLinks(document);

  document.addEventListener('touchstart', onTouchStart, true);
  document.addEventListener('touchmove', onTouchMove, true);
  document.addEventListener('touchend', onTouchEnd, true);
  document.addEventListener('touchcancel', function () { touchStart = null; moved = false; }, true);
  document.addEventListener('click', function (event) {
    if (event.detail === 0 || !('ontouchstart' in window)) openWhatsapp(event);
  }, true);
  document.addEventListener('shopify:section:load', function (event) { updateWhatsappLinks(event.target || document); });

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node && node.nodeType === 1) updateWhatsappLinks(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

(function () {
  if (window.__lgWomensWeddingRingOptions) return;
  window.__lgWomensWeddingRingOptions = true;

  var RING_SIZES = ['4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '12.5', '13'];
  var retryTimer = null;

  function isWomensWeddingRingProduct() {
    if (!document.body || !document.body.classList.contains('template-product')) return false;
    var collections = (document.body.getAttribute('data-lg-product-collections') || '').split(',');
    return collections.indexOf('women-wedding-rings') !== -1;
  }

  function findProductForm() {
    return document.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"], .t4s-form__product');
  }

  function textOf(element) {
    return (element && element.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function findOptionBlock(pattern) {
    var scope = document.querySelector('.t4s-product__info-container') || document;
    var candidates = scope.querySelectorAll('.tpo_option-container, .tpo_option, .tpo_option-wrapper, .t4s-swatch__option, [data-swatch-option], fieldset, [data-option]');
    for (var i = 0; i < candidates.length; i += 1) {
      if (pattern.test(textOf(candidates[i]))) return candidates[i];
    }
    return null;
  }

  function hasRingSizeControl(form) {
    if (form.querySelector('[data-lg-ring-size-option], [data-lg-ring-size-select]')) return true;
    return !!findOptionBlock(/select\s*ring\s*size|ring size/i);
  }

  function ensureStyle() {
    if (document.getElementById('lg-womens-wedding-ring-options-style')) return;
    var style = document.createElement('style');
    style.id = 'lg-womens-wedding-ring-options-style';
    style.textContent = [
      '.lg-wedding-ring-size-option{margin:10px 0 18px}',
      '.lg-wedding-ring-size-option__label{display:block;margin:0 0 8px;color:#222;font-size:14px;font-weight:500;line-height:1.4}',
      '.lg-wedding-ring-size-option__select{display:block;width:100%;height:48px;min-height:48px;padding:0 16px;border:1px solid #d8d1c3;border-radius:0;background:#fff;color:#222;font-size:14px;font-weight:500;line-height:1.4;box-shadow:none}',
      '.lg-wedding-ring-size-option__select:hover,.lg-wedding-ring-size-option__select:focus{border-color:#8a6a2f;outline:none}',
      '.lg-wedding-ring-size-guide{margin:10px 0 18px}',
      '.lg-wedding-ring-size-guide a{display:inline-flex;align-items:center;gap:7px;color:#222;font-size:14px;font-weight:500;text-decoration:underline;text-underline-offset:3px}',
      '.lg-wedding-ring-size-guide a:hover{color:#8a6a2f}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function createRingSizeControl(form) {
    var wrapper = document.createElement('div');
    wrapper.className = 'lg-wedding-ring-size-option';
    wrapper.setAttribute('data-lg-ring-size-option', '');

    var label = document.createElement('label');
    label.className = 'lg-wedding-ring-size-option__label';
    label.setAttribute('for', 'lg-wedding-ring-size-select');
    label.textContent = 'Select Ring Size (US):';

    var select = document.createElement('select');
    select.id = 'lg-wedding-ring-size-select';
    select.className = 'lg-wedding-ring-size-option__select';
    select.name = 'properties[Ring Size (US)]';
    select.setAttribute('data-lg-ring-size-select', '');

    RING_SIZES.forEach(function (size) {
      var option = document.createElement('option');
      option.value = size;
      option.textContent = size;
      select.appendChild(option);
    });

    wrapper.appendChild(label);
    wrapper.appendChild(select);

    var guide = document.createElement('div');
    guide.className = 'lg-wedding-ring-size-guide';
    guide.innerHTML = '<a href="https://www.luminarygem.com/pages/ring-size-guide" target="_blank" rel="noopener"><i class="las la-ring" aria-hidden="true"></i><span>Ring Size Guide</span></a>';
    wrapper.appendChild(guide);

    var metalBlock = findOptionBlock(/metal type/i);
    var stoneBlock = findOptionBlock(/select\s*stone\s*size|stone size/i);
    var buttons = form.querySelector('.t4s-product-form__buttons');

    if (metalBlock && metalBlock.parentNode) metalBlock.insertAdjacentElement('afterend', wrapper);
    else if (stoneBlock && stoneBlock.parentNode) stoneBlock.parentNode.insertBefore(wrapper, stoneBlock);
    else if (buttons && buttons.parentNode) buttons.parentNode.insertBefore(wrapper, buttons);
    else form.appendChild(wrapper);

    return wrapper;
  }

  function visibleEngravingField(form) {
    var fields = form.querySelectorAll('.luminary-engraving-field');
    for (var i = 0; i < fields.length; i += 1) {
      if (!fields[i].hidden && !fields[i].querySelector('input:disabled')) return fields[i];
    }
    return null;
  }

  function ensureEngravingField(form, ringControl) {
    var engraving = visibleEngravingField(form);
    if (engraving) return engraving;

    engraving = form.querySelector('[data-luminary-engraving-field]');
    if (!engraving) {
      engraving = document.createElement('div');
      engraving.className = 'luminary-engraving-field luminary-engraving-field--wedding-ring';
      engraving.innerHTML = '<label for="luminary-wedding-engraving" class="luminary-engraving-field__label">Complimentary Engraving:</label><input id="luminary-wedding-engraving" class="luminary-engraving-field__input" type="text" name="properties[Complimentary Engraving]" maxlength="80" placeholder="Add a soulful message to the inside of your band">';
    }

    engraving.hidden = false;
    var input = engraving.querySelector('input');
    if (input) input.disabled = false;

    var stoneBlock = findOptionBlock(/select\s*stone\s*size|stone size/i);
    var nativeRingBlock = findOptionBlock(/select\s*ring\s*size|ring size/i);
    var anchor = stoneBlock || ringControl || nativeRingBlock;
    var buttons = form.querySelector('.t4s-product-form__buttons');

    if (anchor && anchor.parentNode) anchor.insertAdjacentElement('afterend', engraving);
    else if (buttons && buttons.parentNode) buttons.parentNode.insertBefore(engraving, buttons);
    else form.appendChild(engraving);

    return engraving;
  }

  function initRingOptions() {
    if (!isWomensWeddingRingProduct()) return;
    var form = findProductForm();
    if (!form) return;

    ensureStyle();
    var ringControl = form.querySelector('[data-lg-ring-size-option]');
    if (!hasRingSizeControl(form)) ringControl = createRingSizeControl(form);
    ensureEngravingField(form, ringControl);
  }

  function scheduleInit() {
    var attempts = 0;
    if (retryTimer) clearInterval(retryTimer);
    initRingOptions();
    retryTimer = setInterval(function () {
      attempts += 1;
      initRingOptions();
      if (attempts >= 20) clearInterval(retryTimer);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleInit);
  else scheduleInit();
  document.addEventListener('shopify:section:load', scheduleInit);
  document.addEventListener('tpo_loaded', scheduleInit);
  document.addEventListener('easify:loaded', scheduleInit);
})();